module.exports = __webpack_public_path__ + "img/sponsorM26.ead9983c.png";